import React, { useEffect, useState } from 'react';
import { Button } from '../button/Button';
import { useTranslation } from 'react-i18next';
import './SecretPinModal.css';

export const SecretPinModal = ({ mode, purpose = 'unlock', onSubmit, onCancel }) => {
    const { t } = useTranslation();
    const [pin, setPin] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState('');
    const isSetup = mode === 'setup';
    const copyKey = isSetup
        ? purpose === 'changePin'
            ? 'changePin'
            : purpose === 'createSecret'
                ? 'createSecretSetup'
                : purpose === 'makeSecret'
                    ? 'makeSecretSetup'
                    : 'setPin'
        : purpose === 'changePin'
            ? 'verifyCurrentPin'
            : purpose;

    useEffect(() => {
        setPin('');
        setConfirmation('');
        setError('');
    }, [mode]);

    const handleSubmit = async (event) => {
        event?.preventDefault();
        if (!/^\d{4,6}$/.test(pin)) {
            setError(t('secretCollections.pinValidation'));
            return;
        }
        if (isSetup && pin !== confirmation) {
            setError(t('secretCollections.pinMismatch'));
            return;
        }
        const accepted = await onSubmit(pin);
        if (!accepted) setError(t('secretCollections.invalidPin'));
    };

    return (
        <div className="secret-pin-overlay" onClick={onCancel}>
            <div
                aria-labelledby="secret-pin-title"
                aria-modal="true"
                className="secret-pin-modal"
                onClick={(event) => event.stopPropagation()}
                role="dialog"
            >
                <h2 id="secret-pin-title">
                    {t(`secretCollections.pinModal.${copyKey}.title`)}
                </h2>
                <p>{t(`secretCollections.pinModal.${copyKey}.description`)}</p>
                <form onSubmit={handleSubmit}>
                    <input
                        aria-label={t('secretCollections.pin')}
                        autoComplete={isSetup ? 'new-password' : 'current-password'}
                        autoFocus
                        inputMode="numeric"
                        maxLength="6"
                        type="password"
                        value={pin}
                        onChange={(event) => setPin(event.target.value.replace(/\D/g, ''))}
                    />
                    {isSetup && (
                        <input
                            aria-label={t('secretCollections.confirmPin')}
                            autoComplete="new-password"
                            inputMode="numeric"
                            maxLength="6"
                            type="password"
                            value={confirmation}
                            onChange={(event) => setConfirmation(event.target.value.replace(/\D/g, ''))}
                        />
                    )}
                </form>
                {error && <p className="secret-pin-error">{error}</p>}
                <div className="secret-pin-actions">
                    <Button text={t('confirmationDialog.cancel')} status="secondary" onClick={onCancel} />
                    <Button text={t('confirmationDialog.confirm')} type="primary" onClick={handleSubmit} />
                </div>
            </div>
        </div>
    );
};
